/**
 * Mixin for ApexCharts Dark Mode Support
 *
 * This mixin provides a computed property that returns dark mode theme settings
 * for ApexCharts based on the current Vuetify theme.
 *
 * Usage:
 * 1. Import the mixin in your chart component
 * 2. Add it to the mixins array
 * 3. Merge apexChartsDarkModeOptions with your chartOptions
 *
 * Example:
 * import apexChartsDarkMode from '@/mixins/apexChartsDarkMode';
 *
 * export default {
 *   mixins: [apexChartsDarkMode],
 *   computed: {
 *     chartOptions() {
 *       return {
 *         ...this.apexChartsDarkModeOptions,
 *         // your chart-specific options
 *       };
 *     }
 *   }
 * }
 */

export default {
  computed: {
    apexChartsDarkModeOptions() {
      const isDark = this.$vuetify?.theme?.dark ?? false;

      return {
        theme: {
          mode: isDark ? "dark" : "light",
        },
        chart: {
          background: "transparent",
          foreColor: isDark ? "#E0E0E0" : "#373d3f",
        },
        grid: {
          borderColor: isDark ? "#424242" : "#e0e0e0",
        },
        xaxis: {
          axisBorder: {
            color: isDark ? "#616161" : "#e0e0e0",
          },
          axisTicks: {
            color: isDark ? "#616161" : "#e0e0e0",
          },
          labels: {
            style: {
              colors: isDark ? "#B0B0B0" : "#616161",
            },
          },
          title: {
            style: {
              color: isDark ? "#E0E0E0" : "#373d3f",
            },
          },
        },
        yaxis: {
          axisBorder: {
            color: isDark ? "#616161" : "#e0e0e0",
          },
          labels: {
            style: {
              colors: isDark ? "#B0B0B0" : "#616161",
            },
          },
          title: {
            style: {
              color: isDark ? "#E0E0E0" : "#373d3f",
            },
          },
        },
        legend: {
          labels: {
            colors: isDark ? "#E0E0E0" : "#373d3f",
          },
        },
        tooltip: {
          theme: isDark ? "dark" : "light",
        },
        dataLabels: {
          style: {
            colors: ["#fff"],
          },
        },
      };
    },
  },
};
